import clsx from "clsx";
import PropTypes from "prop-types";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import componentStyles from "assets/theme/components/headers/page-title-header.js";

const useStyles = makeStyles(componentStyles);

const PageTitleHeader = ({ title, titleId, truncate = false, wrap = false, small = false, style }) => {
  const classes = useStyles();
  return (
    <Grid container classes={{ root: classes.containerPadding }} style={style}>
      <Grid
        item
        xs={12}
        md={12}
        className={clsx(classes.titleGrid, {
          [classes.titleGridTruncate]: truncate,
          [classes.titleGridWrap]: wrap,
        })}
      >
        <Box
          data-testid={"page-title-header-" + titleId}
          className={clsx(classes.pageTitle, {
            [classes.pageTitleTruncate]: truncate,
            [classes.pageTitleWrap]: wrap,
            [classes.pageTitleSmall]: small,
          })}
        >
          {title}
        </Box>
      </Grid>
    </Grid>
  );
};

PageTitleHeader.propTypes = {
  title: PropTypes.string,
  truncate: PropTypes.bool,
  wrap: PropTypes.bool,
  small: PropTypes.bool,
};

export default PageTitleHeader;
